// extracted by mini-css-extract-plugin
export default {"searchGroup":"LiveSearch_searchGroup__hCmKB","iconWrapper":"LiveSearch_iconWrapper__bVB3G","icon":"LiveSearch_icon__3uv5W","inputField":"LiveSearch_inputField__2TDJp"};